import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CloudSnow = createReactComponent("CloudSnow", ["svg", defaultAttributes, [["path", {
  d: "M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25",
  key: "1kj545"
}], ["line", {
  x1: "8",
  y1: "16",
  x2: "8.01",
  y2: "16",
  key: "1m975f"
}], ["line", {
  x1: "8",
  y1: "20",
  x2: "8.01",
  y2: "20",
  key: "aukqwv"
}], ["line", {
  x1: "12",
  y1: "18",
  x2: "12.01",
  y2: "18",
  key: "rbtten"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12.01",
  y2: "22",
  key: "1qhv3z"
}], ["line", {
  x1: "16",
  y1: "16",
  x2: "16.01",
  y2: "16",
  key: "doshnj"
}], ["line", {
  x1: "16",
  y1: "20",
  x2: "16.01",
  y2: "20",
  key: "th9hkv"
}]]]);
export default CloudSnow;